module.exports = __webpack_public_path__ + "static/media/speed2-min.49018498.jpg";